import { useLanguage } from '../contexts/LanguageContext';

/**
 * Custom hook for translations
 * Provides a simple interface to the LanguageContext
 *
 * Usage:
 * const { t, currentLanguage, changeLanguage } = useTranslation();
 * <h1>{t('cms.dashboard.title')}</h1>
 * <p>{t('cms.validation.minLength', { min: 5 })}</p>
 */
export const useTranslation = () => {
  const {
    t,
    currentLanguage,
    changeLanguage,
    availableLanguages,
    isLoading,
    getCurrentLanguageInfo,
    getContentLanguage
  } = useLanguage();

  return {
    t,
    currentLanguage,
    changeLanguage,
    availableLanguages,
    isLoading,
    getCurrentLanguageInfo,
    getContentLanguage
  };
};

export default useTranslation;
